<template>
  <div class='production-list'>
    <!-- <p class='header'><router-link to='/navigator' >首页</router-link> > 产品路演平台</p> -->
     <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{ serviceMsg.serviceName }}</el-breadcrumb-item>
      <!-- <el-breadcrumb-item>详情</el-breadcrumb-item> -->
    </el-breadcrumb>
    <div class='list' v-loading="loading">
      <Item v-for='(item, index) in productionList' :key='index' :info='item'></Item>
    </div>
    <div class='pages main-pagination' v-show='total > condition.pageRows'>
      <el-pagination
      :page-size="condition.pageRows" @current-change="handleCurrentChange"
      layout="total, prev, pager, next, jumper" background
      :total="total">
    </el-pagination>
    </div>

    <Nothing v-if="!productionList.length && !loading"></Nothing>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Item from './child/Item';

export default {
  data() {
    return {
      productionList : [],
      condition: {
        currPage: 1,
        pageRows: 10,
      },
      total: 0,
      loading: false,
    };
  },
  methods: {
    // 分页
    handleCurrentChange(page) {
      this.condition.currPage = page;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/products/roadshow/list`, {
        ...this.condition,
        parkId: this.currentParkId,
      }).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          this.productionList = res.resData.pageList ? res.resData.pageList : [];
          if (!this.productionList.length) {
            this.nothing = true;
          }
          this.total = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
        }
      });
    },
  },
  computed: {
    ...mapGetters(['currentParkId', 'parkServiceList']),
  },
  components: { Item },
  created() {
    if (this.parkServiceList.length) {
      this.serviceMsg = this.parkServiceList.find((val) => {
        return val.serviceFlag === 7;
      });
      this.getList();
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.production-list{
  padding-bottom: 30px;
  .header{
    margin-bottom: 20px;
    a{
      color: #333333;
    }
    a:hover{
      text-decoration: underline;
      color: #999999;
    }
    font-size: 12px;
    line-height: 20px;
    color: #333333;
  }
  .pages{
    margin-top: 60px;
    text-align: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/navigator/productions/components/List.vue